/* eslint-disable max-len */
import { DASHBOARD_STATUS_COLOR_MAP } from '../constants';

const STATUS_COLORS = DASHBOARD_STATUS_COLOR_MAP;
const IN_TRANSIT_COLORS = STATUS_COLORS['In Transit'];
const DELIVERED_COLORS = STATUS_COLORS.Delivered;
const IN_PROCESS_COLORS = STATUS_COLORS['In Process'];
const CANCELLED_COLORS = STATUS_COLORS.Cancelled;
const ALL_COLORS = STATUS_COLORS.All;

const gridView1Styles = () => ({
    mainDiv: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: '#F5F5F5',
        padding: '16px',
    },
    // ========== FILTER BAR ==========
    // Main container - Full width filter bar with margin and border radius
    filterBarContainer: {
        margin: 0,
        padding: '16px 24px',
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        border: '1px solid #F0F0F0',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        marginBottom: 0,
    },

    // Top row with date picker, dropdowns, search, and action buttons
    topFilterRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
        paddingBottom: 16,
        borderBottom: '1px solid #F0F0F0',
    },

    // Bottom row with quick filters and more filters
    bottomFilterRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
    },

    // Left section - quick filters container
    quickFiltersSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flex: 1,
    },

    // Right section - more filters container
    moreFiltersSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },

    // ========== REUSABLE - Section labels (used by Quick Filters and More Filters) ==========
    filterSectionLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: '#595959',
        marginRight: 8,
        whiteSpace: 'nowrap',
    },

    // ========== Date Range Picker (single RangePicker component) ==========
    dateRangePicker: {
        '& .ant-picker-input': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-picker-input input::placeholder': {
            color: '#000000',
        },
        '& .ant-picker-suffix': {
            fontSize: 16,
            color: '#000000',
        },
        '& .ant-picker-separator': {
            color: '#000000',
            fontSize: 12,
            fontWeight: 500,
        },
        '& .ant-picker-active-bar': {
            backgroundColor: '#165ACE',
        },
        borderRadius: '18px !important',
        border: '1px solid #000000 !important',
    },

    resetFilter: {
        color: '#DF1D1D',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        marginLeft: 16,
        fontFamily: 'Open Sans',
    },

    // ========== REUSABLE - Dropdown (Protocol ID, Origin Name, Destination Name, Destination Country, Carrier) ==========
    dropdownSelect: {
        minWidth: 150,
        '& .ant-select-selector': {
            borderRadius: '18px !important',
            border: '1px solid #000000 !important',
            paddingLeft: '16px !important',
            paddingRight: '12px !important',
        },
        '& .ant-select-selection-item': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-selection-placeholder': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-arrow': {
            fontSize: 12,
            color: '#000000',
        },
        '&:hover .ant-select-selector': {
            borderColor: '#000000 !important',
        },
    },

    // ========== Connected Input Group - Left side (Consignment No. dropdown) ==========
    inputGroupSelect: {
        width: 200,
        '& .ant-select-selector': {
            borderRadius: '18px 0 0 18px !important',
            border: '1px solid #000000 !important',
            borderRight: 'none !important',
            paddingLeft: '16px !important',
            paddingRight: '12px !important',
        },
        '& .ant-select-selection-item': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-selection-placeholder': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-arrow': {
            fontSize: 12,
            color: '#000000',
        },
    },

    // ========== Connected Input Group - Right side (Search input) ==========
    inputGroupInput: {
        flex: 1,
        marginLeft: -1,
        minWidth: 300,
        fontSize: 12,
        fontWeight: 400,
        color: '#000000',
        borderRadius: '0 18px 18px 0 !important',
        border: '1px solid #000000 !important',
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
        '& .ant-input::placeholder': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
    },

    input: {
        flex: 1,
        marginLeft: -1,
        width: 150,
        fontSize: 12,
        fontWeight: 400,
        color: '#000000',
        borderRadius: '18px !important',
        border: '1px solid #000000 !important',
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
    },

    moreFiltersDropdownSelect: {
        minWidth: 150,
        '& .ant-select-selector': {
            borderRadius: '18px !important',
            border: '1px solid #000000 !important',
            paddingLeft: '16px !important',
            paddingRight: '12px !important',
        },
        '& .ant-select-selection-item': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-selection-placeholder': {
            fontSize: 12,
            fontWeight: 400,
        },
        '& .ant-select-arrow': {
            fontSize: 12,
            color: '#000000',
        },
        '&:hover .ant-select-selector': {
            borderColor: '#000000 !important',
        },
    },

    // Connected input group container
    connectedInputGroup: {
        display: 'flex',
        flex: 1,
        minWidth: 300,
    },

    // ========== REUSABLE - Icon Buttons (3 buttons use this) ==========
    // Used by: Refresh, Download
    iconButton: {
        width: 36,
        height: 36,
        minWidth: 36,
        padding: 0,
        borderRadius: '18px !important',
        border: '1px solid #000000 !important',
        backgroundColor: '#FFFFFF !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        cursor: 'pointer',
        transition: 'all 0.3s',
        color: '#000000 !important',
        '& .anticon': {
            fontSize: 16,
            color: '#595959',
        },
    },

    // ========== REUSABLE - Base Tag Style (ALL quick filter tags share this) ==========
    filterTagBase: {
        padding: '4px 16px',
        borderRadius: 14,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'all 0.3s',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
    },

    // In Transit tag variant (yellow)
    filterTagInTransit: {
        backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        color: IN_TRANSIT_COLORS.textColor,
        '&:hover': {
            backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        },
    },

    filterTagInTransitActive: {
        backgroundColor: IN_TRANSIT_COLORS.textColor,
        color: IN_TRANSIT_COLORS.backgroundColor,
    },

    filterTagDelivered: {
        backgroundColor: DELIVERED_COLORS.backgroundColor,
        color: DELIVERED_COLORS.textColor,
        '&:hover': {
            backgroundColor: DELIVERED_COLORS.backgroundColor,
        },
    },

    filterTagDeliveredActive: {
        backgroundColor: DELIVERED_COLORS.textColor,
        color: DELIVERED_COLORS.backgroundColor,
    },

    filterTagInProcess: {
        backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        color: IN_PROCESS_COLORS.textColor,
        '&:hover': {
            backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        },
    },

    filterTagInProcessActive: {
        backgroundColor: IN_PROCESS_COLORS.textColor,
        color: IN_PROCESS_COLORS.backgroundColor,
    },

    filterTagCancelled: {
        backgroundColor: CANCELLED_COLORS.backgroundColor,
        color: CANCELLED_COLORS.textColor,
        '&:hover': {
            backgroundColor: CANCELLED_COLORS.backgroundColor,
        },
    },

    filterTagCancelledActive: {
        backgroundColor: CANCELLED_COLORS.textColor,
        color: CANCELLED_COLORS.backgroundColor,
    },

    filterTagAll: {
        backgroundColor: ALL_COLORS.backgroundColor,
        color: ALL_COLORS.textColor,
        '&:hover': {
            backgroundColor: ALL_COLORS.backgroundColor,
        },
    },

    // Action buttons group container
    actionButtonsGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginLeft: 'auto',
    },

    // ========== RESPONSIVE BEHAVIOR ==========
    '@media (max-width: 1200px)': {
        topFilterRow: {
            gap: 8,
        },
        connectedInputGroup: {
            minWidth: 250,
        },
        cardsContainer: {
            padding: 20,
        },
    },

    '@media (max-width: 768px)': {
        filterBarContainer: {
            padding: '12px 16px',
            margin: 0,
        },
        topFilterRow: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 8,
        },
        bottomFilterRow: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 12,
        },
        connectedInputGroup: {
            minWidth: 'auto',
            width: '100%',
        },
        dateRangePicker: {
            width: '100%',
        },
        actionButtonsGroup: {
            marginLeft: 0,
            justifyContent: 'flex-end',
        },
        quickFiltersSection: {
            flexWrap: 'wrap',
        },
        moreFiltersSection: {
            flexWrap: 'wrap',
        },
        cardsContainer: {
            padding: 16,
        },
        card: {
            padding: 20,
        },
        detailsRow: {
            flexDirection: 'column',
            gap: 12,
        },
    },

    '@media (max-width: 480px)': {
        mainDiv: {
            padding: '8px',
        },
        cardsContainer: {
            paddingTop: 12,
            paddingLeft: 8,
            paddingRight: 8,
        },
        card: {
            padding: 16,
            gap: 16,
        },
        shipmentId: {
            fontSize: 16,
            lineHeight: '22px',
        },
        avatar: {
            width: 40,
            height: 40,
            minWidth: 40,
            borderRadius: 20,
        },
    },

    // ========== GRID VIEW CONTAINER ==========
    cardsContainer: {
        width: '100%',
        padding: '24px 0',
        backgroundColor: '#F5F5F5',
        overflowY: 'auto',
        overflowX: 'hidden',
    },

    // ========== INDIVIDUAL CARD ==========
    card: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        border: '1px solid #E8E8E8',
        padding: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
        transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
        height: '100%',
    },

    // ========== CARD HEADER SECTION ==========
    cardHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
    },

    // Avatar (gray circle placeholder or carrier logo)
    avatar: {
        width: 48,
        height: 48,
        minWidth: 48,
        borderRadius: 24,
        backgroundColor: '#D9D9D9',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },

    // Carrier logo image inside avatar
    carrierLogoImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },

    // Header content wrapper
    headerContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1,
        minWidth: 0,
    },

    // Shipment ID (blue link text)
    shipmentId: {
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '24px',
        color: '#165ACE',
        textDecoration: 'none',
        cursor: 'pointer',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '&:hover': {
            color: '#40A9FF',
        },
    },

    // ========== REUSABLE - ALL status badges (4 status types use this base) ==========
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 12,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '20px',
        width: 'fit-content',
        '& .anticon': {
            fontSize: 14,
        },
    },

    // Status variants (darker colors as per design)
    statusInProcess: {
        backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        color: IN_PROCESS_COLORS.textColor,
        '& .anticon': {
            color: IN_PROCESS_COLORS.textColor,
        },
    },

    statusCancelled: {
        backgroundColor: CANCELLED_COLORS.backgroundColor,
        color: CANCELLED_COLORS.textColor,
        '& .anticon': {
            color: CANCELLED_COLORS.textColor,
        },
    },

    statusInTransit: {
        backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        color: IN_TRANSIT_COLORS.textColor,
        '& .anticon': {
            color: IN_TRANSIT_COLORS.textColor,
        },
    },

    statusDelivered: {
        backgroundColor: DELIVERED_COLORS.backgroundColor,
        color: DELIVERED_COLORS.textColor,
        '& .anticon': {
            color: DELIVERED_COLORS.textColor,
        },
    },

    // ========== CARD DETAILS SECTION ==========
    detailsSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },

    // Details row (Protocol ID / AWB row)
    detailsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
    },

    // Individual detail item (left-aligned)
    detailItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
    },

    // Individual detail item (right-aligned)
    detailItemRight: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
        alignItems: 'flex-end',
    },

    // ========== REUSABLE - ALL labels ==========
    detailLabel: {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '20px',
        color: '#8C8C8C',
    },

    // ========== REUSABLE - ALL detail values (left-aligned) ==========
    detailValue: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },

    // ========== REUSABLE - ALL detail values (right-aligned) ==========
    detailValueRight: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'right',
    },

    // Dash/hyphen for empty values
    emptyValue: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '22px',
        color: '#BFBFBF',
    },

    // ========== LOCATION SECTION (Origin → Destination) ==========
    locationSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        paddingTop: 4,
    },

    // Origin/Destination container (left-aligned)
    locationItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
    },

    // Origin/Destination container (right-aligned)
    locationItemRight: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
        alignItems: 'flex-end',
    },

    // Location header (with icon)
    locationHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        '& .anticon': {
            fontSize: 14,
            color: '#8C8C8C',
        },
    },

    // Location text (city + country) - left-aligned
    locationText: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
    },

    // Location text (city + country) - right-aligned
    locationTextRight: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
        textAlign: 'right',
    },

    // Arrow icon between origin and destination
    locationArrow: {
        fontSize: 20,
        color: '#165ACE !important',
        flexShrink: 0,
        marginTop: 18,
    },

    // ========== DATES SECTION (Pickup Date / Created Date) ==========
    datesSection: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
        paddingTop: 4,
    },

    // ========== LOADING & EMPTY STATES ==========
    centerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 300px)',
        backgroundColor: '#F5F5F5',
    },

    emptyStateText: {
        fontSize: 18,
        fontWeight: 500,
        color: '#8C8C8C',
    },

    loadMoreContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        marginTop: '20px',
    },
});

export {
    gridView1Styles,
};
